import axios from 'axios';

const list = (data) => axios.get('/custom/product/list', data);
const save = (data) => axios.post('/custom/product/saveOrUpdate', data);
const del = (data) => axios.post('/custom/product/delete', data); //delete

export default {
  list,
  save,
  del,
}


